import { render, staticRenderFns } from "./agen.vue?vue&type=template&id=b2054bd0&scoped=true&"
import script from "./agen.vue?vue&type=script&lang=js&"
export * from "./agen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2054bd0",
  null
  
)

export default component.exports